import { fixAmount } from "../../core/utils";
import { ITransaction } from "../transaction/data/entities";
import { IProduct } from "./data/entities";

interface IDirtyAndPercent {
  dirtyWeight: number;
  wastePercent: number;
}

export function calcCleanWeight({ dirtyWeight, wastePercent }: IDirtyAndPercent): number {
  return fixAmount((dirtyWeight * (100 - wastePercent)) / 100);
}

interface IDirtyAndClean {
  dirtyWeight: number;
  cleanWeight: number;
}

export function calcWastePercent({ cleanWeight, dirtyWeight }: IDirtyAndClean): number {
  return fixAmount(100 - (cleanWeight * 100) / dirtyWeight);
}

interface IPercentAndClean {
  wastePercent: number;
  cleanWeight: number;
}

export function calcDirtyWeight({ cleanWeight, wastePercent }: IPercentAndClean): number {
  return fixAmount((cleanWeight * 100) / (100 - wastePercent));
}

export function calcTotalPrice({
  dirtyWeight,
  wastePercent,
  price,
}: {
  dirtyWeight: number;
  wastePercent: number;
  price: number;
}): number {
  const cleanWeight = calcCleanWeight({
    dirtyWeight,
    wastePercent,
  });

  return fixAmount(cleanWeight * price);
}

export function calcCleanWeightFromTransaction(transaction: ITransaction): number | undefined {
  if (transaction.dirtyWeight !== undefined && transaction.wastePercent !== undefined) {
    return fixAmount(calcCleanWeight({ dirtyWeight: transaction.dirtyWeight, wastePercent: transaction.wastePercent }));
  }
}

interface IParams {
  totalDirtyWeight: number;
  totalCleanWeight: number;
  totalAmount: number;
}

export function calcProductListSummary(productList: IProduct[]): IParams {
  const summary: IParams = {
    totalDirtyWeight: 0,
    totalCleanWeight: 0,
    totalAmount: 0,
  };

  productList.forEach((t) => {
    summary.totalDirtyWeight += t.dirtyWeight;
    summary.totalCleanWeight += t.cleanWeight;
    summary.totalAmount += t.totalPrice;
  });

  return summary;
}
